module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.45c750e4.png";